module.exports = __webpack_public_path__ + "static/img/l1.b6f89e15.jpg";